module.exports = __webpack_public_path__ + "img/portfolio-03-481x325.cc7c8624.jpg";